<template>
  <div class="flex flex-col md:flex-row gap-2 pl-2 md:pl-4 md:px-4">
    <div
      class="border px-4 py-2 rounded-[12px] rounded-tl-none text-black font-normal cursor-pointer hover:border hover:border-primary"
      :class="type === 'order' ? '!bg-primary text-white border-primary' : bgColor"
      @click="emit('update:systemMenuType', 'order')"
    >
      Проблема с заказом
    </div>
    <div
      class="border px-4 py-2 rounded-[12px] rounded-tl-none text-black font-normal cursor-pointer hover:border hover:border-primary"
      :class="type === 'channel' ? '!bg-primary text-white border-primary' : bgColor"
      @click="emit('update:systemMenuType', 'channel')"
    >
      Проблема с каналом
    </div>
    <div
      class="border bg-opacity-49 px-4 py-2 rounded-[12px] rounded-tl-none text-black font-normal cursor-pointer hover:border hover:border-primary"
      :class="type === 'payment' ? '!bg-primary text-white border-primary' : bgColor"
      @click="emit('update:systemMenuType', 'payment')"
    >
      Выплаты
    </div>
    <div
      class="border bg-opacity-49 px-4 py-2 rounded-[12px] rounded-tl-none text-black font-normal cursor-pointer hover:border hover:border-primary"
      :class="type === 'other' ? '!bg-primary text-white border-primary' : bgColor"
      @click="emit('update:systemMenuType', 'other')"
    >
      Другое
    </div>
  </div>
</template>

<script lang="ts" setup>
  const props = defineProps<{
    systemMenuType: string;
    bg: string;
  }>();
  const type = ref<string>("");
  const emit = defineEmits(["update:systemMenuType"]);

  const bgColor = computed(() => {
    return props.bg ? props.bg : "bg-white";
  });

  watch(
    () => props.systemMenuType,
    (newVal) => {
      type.value = newVal;
    }
  );

  onMounted(() => {
    type.value = props.systemMenuType;
  });
</script>
